<template>
    <div class="qualityDetail">
            <div class="leftBox">
                <ul>
                    <li>
                        <p class="name">
                            <span class="circle"></span>
                            活动类别：
                        </p>
                        <p class="detail">{{getType(form.type)}}</p>
                    </li>
                    <li>
                        <p class="name">
                            <span class="circle"></span>
                            活动名称：
                        </p>
                        <p class="detail">{{form.name}}</p>
                    </li>
                    <li>
                        <p class="name">
                            <span class="circle"></span>
                            担任角色：
                        </p>
                        <p class="detail">{{getRole(form.role)}}</p>
                    </li>                   
                    <li>
                        <p class="name">
                            <span class="circle"></span>
                            活动时间：
                        </p>   
                        <p class="detail" v-if="form.startDate!==null&&form.endDate!==null&&form.startDate!=='null'&&form.endDate!=='null'">
                            {{form.startDate}}—{{form.endDate}}
                        </p>  
                        <p class="detail" v-if="form.startDate!==null&&form.endDate==null||form.startDate!=='null'&&form.endDate=='null'">
                            {{form.startDate}}
                        </p>
                        <p class="detail" v-if="form.endDate!==null&&form.startDate==null||form.startDate=='null'&&form.endDate!=='null'">
                            {{form.endDate}}
                        </p>
                        <p class="detail" v-if="form.startDate==null&&form.endDate==null||form.startDate=='null'&&form.endDate=='null'">
                            
                        </p>  
                    </li>




                    <li>
                        <p class="name">
                            <span class="circle"></span>
                            组织单位：
                        </p>
                        <p class="detail">{{form.organizationalUnit}}</p>
                    </li>
                    <li>
                        <p class="name">
                            <span class="circle"></span>
                            负责教师：
                        </p>
                        <p class="detail">{{form.chargeTeacher}}</p>
                    </li>
                </ul>
            </div>
            <div class="rightBox" v-if="form.picUrl&&form.picUrl.length"  >
                <div class="swiper">
                    <ul :style="{ marginLeft: -swiperIndex*270 + 'px' }">
                        <li v-for="(value,index) in form.picUrl" :key="index">
                            <img
                                :src="value.url||'/acapi' + value"
                                @click="openImg(value)"
                                alt=""
                            />
                        </li>
                    </ul>
                </div>
                <div class="btnBox">
                    <div class="leftBtn btn" @click="changeSwiper(-1)" ><img src="~@img/xueyezixun/consultant/student/mine/icon_left.png" alt=""/></div>
                    <div class="rightBtn btn" @click="changeSwiper(1)"><img src='~@img/xueyezixun/consultant/student/mine/icon_right.png' alt=""/></div>
                </div>
            </div>
        </div>
</template>
<script>
export default {
    name: "qualityDetail",
    props: ['form'],
    components: {
    },
    data() {
        return {
            swiperIndex: 0,
            studentId:'',
            // type: '',//1.研究性学习 2大学先修课 3社会实践 4等级考试 5高校营 6其他类
            // name: '',//活动名称
            // role: '',//担任角色
            // startDate: null,//获奖日期
            // endDate: null,//获奖日期
            // organizationalUnit: '',//组织单位
            // chargeTeacher: '',//组织单位
            // picUrl: []//上传图片
        }
    },
    created() {},
    mounted(){},
    methods: {
        openImg(value) {
            window.open(value.url||'http://zq.api.chencaiwang.com' + value);
        },
        changeSwiper(value) {
            let length = this.form.picUrl.length;
            let swiperIndex = this.swiperIndex;
            if(value>0) {
                if(swiperIndex === length-1){
                    return;
                }
                swiperIndex ++;
                this.swiperIndex = swiperIndex;
            }else {
                if(swiperIndex === 0){
                    return;
                }
                swiperIndex --;
                this.swiperIndex = swiperIndex;
            }
        },
        getType(type) {
            // type: '',//1研究性学习 2大学先修课 3社会实践 4等级考试 5高校营 6其他类
            switch(Number(type)) {
                case 1:
                    return '研究性学习'
                    break;
                case 2:
                    return '大学先修课'
                    break;
                case 3:
                    return '社会实践'
                    break;
                case 4:
                    return '等级考试'
                    break;
                case 5:
                    return '高校营'
                    break;
                case 6:
                    return '其他类'
                    break;
            }
        },
        getRole(type) {
            // type: '',//1研究性学习 2大学先修课 3社会实践 4等级考试 5高校营 6其他类
            switch(Number(type)) {
                case 1:
                    return '负责人'
                    break;
                case 2:
                    return '参与者'
                    break;
                case 3:
                    return '合作者'
                    break;
                case 4:
                    return '志愿者'
                    break;
                case 5:
                    return '作者'
                    break;
                case 6:
                    return '其他'
                    break;
            }
        }
    },
}
</script>
<style scoped lang="less">
.qualityDetail {
        display: flex;
        align-items: center;
        height: 384px;
        background-color: #fff;
        padding: 0px 130px 20px 130px;
        .name {
            font-size: 16px;
            display: flex;
            align-items: center;
            line-height: 24px;
            .circle {
                width: 12px;
                height: 12px;
                background: #00A2FF;
                border: 2px solid #D4F0FF;
                border-radius: 50%;
                margin-right: 5px;
            }
        }
        .leftBox {
            width: 360px;
            margin-right: 20px;
            ul {
                li {
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    height: 24px;
                    line-height: 24px;
                    margin-bottom: 24px;

                    .detail {
                        padding-left: 20px;
                        font-weight: bold;
                    }
                }
            }
        }
        .rightBox {
            box-sizing: border-box;
            width: 350px;
            padding: 0 40px;
            position: relative;
            .btnBox {
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -19px;
                width: 100%;
                height: 38px;
                .btn {
                    width: 30px;
                    height: 30px;
                }
                .leftBtn {
                    position: absolute;
                    left: 0;
                }
                .rightBtn {
                    position: absolute;
                    right: 0;
                }
            }
            .swiper {
                width: 270px;
                height: 384px;
                overflow: hidden;
            }
            ul {
                width: 1300px;
                height: 384px;
                transition: all .3s;
                li {
                    width: 270px;
                    height: 384px;
                    display: flex;
                    align-items: center;
                    float: left;
                    img {
                        display: inline-block;
                        width: 100%;
                    }
                }
            }

        }
}
</style>